<template>
  <div class="cloud-partyBuilding">
    <div class="cloud-partyBuilding-l">
      <div
        class="cloud-partyBuilding-title"
        style="height: calc(420 / 1080 * 100vh)"
      >
        <div class="cloud-partyBuilding-title-title">
          <img
            src="@/assets/images/groupTitle.png"
            alt=""
            style="width: 100%; height: 4vh"
          />
          <p>党组织结构</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '8%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 88%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div class="cloud-partyBuilding-title-content">
          <FixedTree :treeData="treeData" />
        </div>
      </div>

      <div
        class="cloud-partyBuilding-title"
        style="
          height: calc(470 / 1080 * 100vh);
          margin-top: calc(440 / 1080 * 100vh);
        "
      >
        <div class="cloud-partyBuilding-title-title">
          <img
            src="@/assets/images/groupTitle.png"
            alt=""
            style="width: 100%; height: 4vh"
          />
          <p>学习教育</p>
          <div>更多 <i class="el-icon-caret-right"></i></div>
        </div>
        <div class="cloud-partyBuilding-title-content">
          <ul class="ulTable" style="height: calc(400 / 1080 * 100vh)">
            <li
              v-for="value in speechList"
              :key="value"
              @click="speechHandleQuery(value)"
            >
              {{ value.speechTitle }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="cloud-partyBuilding-c">
      <div class="cloud-partyBuilding-c-title">委员信息</div>
    </div>

    <div class="cloud-partyBuilding-r">
      <div
        class="cloud-partyBuilding-title"
        style="height: calc(420 / 1080 * 100vh)"
      >
        <div class="cloud-partyBuilding-title-title">
          <img
            src="@/assets/images/groupTitle.png"
            alt=""
            style="width: 100%; height: 4vh"
          />
          <p>党建活动</p>
          <div>更多 <i class="el-icon-caret-right"></i></div>
        </div>
        <div class="cloud-partyBuilding-title-content">
          <ul class="ulTable" style="height: calc(350 / 1080 * 100vh)">
            <li
              v-for="value in videoList"
              :key="value"
              @click="videoHandleQuery(value)"
            >
              {{ value.videoContent }}
            </li>
          </ul>
        </div>
      </div>

      <div
        class="cloud-partyBuilding-title"
        style="
          height: calc(470 / 1080 * 100vh);
          margin-top: calc(440 / 1080 * 100vh);
        "
      >
        <div class="cloud-partyBuilding-title-title">
          <img
            src="@/assets/images/groupTitle.png"
            alt=""
            style="width: 100%; height: 4vh"
          />
          <p>党建品牌矩阵</p>
          <div>更多 <i class="el-icon-caret-right"></i></div>
        </div>
        <div class="cloud-partyBuilding-title-content">
          <ul class="ulTable" style="height: calc(400 / 1080 * 100vh)">
            <li
              v-for="value in partyClassList"
              :key="value"
              @click="classHandleQuery(value)"
            >
              {{ value.classTitle }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <el-drawer
      :title="title"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="80%"
    >
      <div
        style="color: #666; padding: 10px; text-align: left; text-indent: 30px"
        v-html="content"
      ></div>
      <ul>
        <li v-for="(photo, photoIndex) in imageLists" :key="photoIndex">
          <img :src="pathSrc + photo" class="photo-image" />
        </li>
      </ul>
      <video
        v-if="videoSource != ''"
        width="96%"
        height="auto"
        controls
        :src="pathSrc + videoSource"
      ></video>
    </el-drawer>
  </div>
</template>

<script>
import FixedTree from "../../components/FixedTree.vue";
import { partyBuilding } from "@/public/api.js";

// 引入路由实例
export default {
  name: "partyBuilding",
  components: {
    FixedTree,
  },
  data() {
    return {
      TunnelsData: {},
      pathSrc:
        window.location.hostname === "39.101.122.159"
          ? "http://" + window.location.hostname + ":19001/prod-api"
          : "http://" + window.location.hostname + ":10181/stage-api",
      currentVideoSrc: "https://www.baidu.com/",
      urlType: 1,
      form: {
        itemId: 0,
        type: "image", // 类型 image：相册， video：视频 ，speech：重要讲话， Class：重点党课话
        pageNum: 1, // 页码
        pageSize: 10, // 每页显示条数
      },
      imageList: [], // 相册列表
      videoList: [
        {
          id: 1,
          videoContent: "“五动青春”分品牌视频",
        },
        {
          id: 1,
          videoContent: "一分公司“五一同新”子品牌",
        },
        {
          id: 1,
          videoContent: "“五动青春”分品牌",
        },
        {
          id: 1,
          videoContent: "“磐心共筑”分品牌",
        },
      ], // 视频列表
      speechList: [
        {
          id: 1,
          speechTitle:
            "磐心共筑简报2025年第12期：中铁五局JZTJ-2标项目部掀起学习全国劳动模范李吉同志先进事迹热潮",
          speechContent:
            "4月28日，庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会在北京隆重举行，中铁五局员工李吉同志荣获“全国劳动模范”荣誉称号。这一殊荣不仅是对李吉个人卓越贡献的高度认可，更是对全体中铁五局建设者辛勤付出的巨大鼓舞。消息传来，济枣铁路项目部及各分部迅速响应，掀起了一场学习李吉同志先进事迹的热潮。鉴于JZTJ-2标的特殊情况，项目部于“五一”期间，分别在管段内的济泰段和曲阜段组织员工召开了学习全国劳动模范李吉同志先进事迹专题会。会上，大家认真观看了李吉同志先进事迹宣传视频，全文学习了习近平总书记在庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会上的重要讲话。大家还学习了贵州省劳动模范陈发亚和童甲修的先进事迹。会议要求项目部广大员工要在学习以李吉为代表的劳动模范为榜样，充分发扬劳模精神、工匠精神、劳动精神和创新精神，为高质量建设济枣铁路贡献力量。一要加强学习，提升素质，增强服务项目建设、服务企业发展、服务地方经济建设的本领；二要锚定项目部年度目标任务，不断增强责任感和紧迫感，立足岗位，积极作为，高质量完成本质工作任务；三要增强创新意识，大力推进新工装、新工艺、新工法的广泛应用，立足项目实际积极开展科技攻关和创新创效活动，提升项目管控水平；四要各分部要以此次学习劳模先进事迹为契机，大力开展劳模选树和培养工作，努力政治过硬、业绩突出、事迹感",
          speechTime: "2023-01-01",
          speechPerson: "张三",
        },
        {
          id: 1,
          speechTitle:
            "磐心共筑简报2025年第12期：中铁五局JZTJ-2标项目部掀起学习全国劳动模范李吉同志先进事迹热潮",
          speechContent:
            "4月28日，庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会在北京隆重举行，中铁五局员工李吉同志荣获“全国劳动模范”荣誉称号。这一殊荣不仅是对李吉个人卓越贡献的高度认可，更是对全体中铁五局建设者辛勤付出的巨大鼓舞。消息传来，济枣铁路项目部及各分部迅速响应，掀起了一场学习李吉同志先进事迹的热潮。鉴于JZTJ-2标的特殊情况，项目部于“五一”期间，分别在管段内的济泰段和曲阜段组织员工召开了学习全国劳动模范李吉同志先进事迹专题会。会上，大家认真观看了李吉同志先进事迹宣传视频，全文学习了习近平总书记在庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会上的重要讲话。大家还学习了贵州省劳动模范陈发亚和童甲修的先进事迹。会议要求项目部广大员工要在学习以李吉为代表的劳动模范为榜样，充分发扬劳模精神、工匠精神、劳动精神和创新精神，为高质量建设济枣铁路贡献力量。一要加强学习，提升素质，增强服务项目建设、服务企业发展、服务地方经济建设的本领；二要锚定项目部年度目标任务，不断增强责任感和紧迫感，立足岗位，积极作为，高质量完成本质工作任务；三要增强创新意识，大力推进新工装、新工艺、新工法的广泛应用，立足项目实际积极开展科技攻关和创新创效活动，提升项目管控水平；四要各分部要以此次学习劳模先进事迹为契机，大力开展劳模选树和培养工作，努力政治过硬、业绩突出、事迹感",
          speechTime: "2023-01-01",
          speechPerson: "张三",
        },
        {
          id: 1,
          speechTitle:
            "磐心共筑简报2025年第12期：中铁五局JZTJ-2标项目部掀起学习全国劳动模范李吉同志先进事迹热潮",
          speechContent:
            "4月28日，庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会在北京隆重举行，中铁五局员工李吉同志荣获“全国劳动模范”荣誉称号。这一殊荣不仅是对李吉个人卓越贡献的高度认可，更是对全体中铁五局建设者辛勤付出的巨大鼓舞。消息传来，济枣铁路项目部及各分部迅速响应，掀起了一场学习李吉同志先进事迹的热潮。鉴于JZTJ-2标的特殊情况，项目部于“五一”期间，分别在管段内的济泰段和曲阜段组织员工召开了学习全国劳动模范李吉同志先进事迹专题会。会上，大家认真观看了李吉同志先进事迹宣传视频，全文学习了习近平总书记在庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会上的重要讲话。大家还学习了贵州省劳动模范陈发亚和童甲修的先进事迹。会议要求项目部广大员工要在学习以李吉为代表的劳动模范为榜样，充分发扬劳模精神、工匠精神、劳动精神和创新精神，为高质量建设济枣铁路贡献力量。一要加强学习，提升素质，增强服务项目建设、服务企业发展、服务地方经济建设的本领；二要锚定项目部年度目标任务，不断增强责任感和紧迫感，立足岗位，积极作为，高质量完成本质工作任务；三要增强创新意识，大力推进新工装、新工艺、新工法的广泛应用，立足项目实际积极开展科技攻关和创新创效活动，提升项目管控水平；四要各分部要以此次学习劳模先进事迹为契机，大力开展劳模选树和培养工作，努力政治过硬、业绩突出、事迹感",
          speechTime: "2023-01-01",
          speechPerson: "张三",
        },
        {
          id: 1,
          speechTitle:
            "磐心共筑简报2025年第12期：中铁五局JZTJ-2标项目部掀起学习全国劳动模范李吉同志先进事迹热潮",
          speechContent:
            "4月28日，庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会在北京隆重举行，中铁五局员工李吉同志荣获“全国劳动模范”荣誉称号。这一殊荣不仅是对李吉个人卓越贡献的高度认可，更是对全体中铁五局建设者辛勤付出的巨大鼓舞。消息传来，济枣铁路项目部及各分部迅速响应，掀起了一场学习李吉同志先进事迹的热潮。鉴于JZTJ-2标的特殊情况，项目部于“五一”期间，分别在管段内的济泰段和曲阜段组织员工召开了学习全国劳动模范李吉同志先进事迹专题会。会上，大家认真观看了李吉同志先进事迹宣传视频，全文学习了习近平总书记在庆祝中华全国总工会成立100周年暨全国劳动模范和先进工作者表彰大会上的重要讲话。大家还学习了贵州省劳动模范陈发亚和童甲修的先进事迹。会议要求项目部广大员工要在学习以李吉为代表的劳动模范为榜样，充分发扬劳模精神、工匠精神、劳动精神和创新精神，为高质量建设济枣铁路贡献力量。一要加强学习，提升素质，增强服务项目建设、服务企业发展、服务地方经济建设的本领；二要锚定项目部年度目标任务，不断增强责任感和紧迫感，立足岗位，积极作为，高质量完成本质工作任务；三要增强创新意识，大力推进新工装、新工艺、新工法的广泛应用，立足项目实际积极开展科技攻关和创新创效活动，提升项目管控水平；四要各分部要以此次学习劳模先进事迹为契机，大力开展劳模选树和培养工作，努力政治过硬、业绩突出、事迹感",
          speechTime: "2023-01-01",
          speechPerson: "张三",
        },
      ], // 重要讲话列表
      partyClassList: [
        {
          id: 1,
          classTitle: "一分公司“五一同新”子品牌",
        },
        {
          id: 1,
          classTitle: "“五动青春”分品牌",
        },
        {
          id: 1,
          classTitle: "“磐心共筑”分品牌",
        },
      ], // 重点党课话列表
      title: "", // 弹窗标题
      content: "", // 弹窗内容
      imageLists: [], // 弹窗图片列表
      videoSource: "", // 弹窗视频地址
      drawer: false, // 弹窗是否显示
      direction: "rtl", // 弹窗方向
      treeData: [
        {
          id: 1,
          label: "党支部",
          expanded: true, // 控制是否展开
          active: false, // 控制是否选中
          children: [
            {
              id: 11,
              label: "党支部",
              expanded: true,
              active: false,
              children: [
                { id: 111, label: "委员信息", active: false },
                { id: 112, label: "党员信息", active: false },
              ],
            },
            {
              id: 12,
              label: "党支部",
              expanded: false,
              active: false,
              children: [{ id: 121, label: "委员信息", active: false }],
            },
          ],
        },
      ],
    };
  },
  computed: {},
  mounted() {
    let that = this;
    if (
      window.location.hostname !== "sd.yongsixinxi.com" &&
      window.location.hostname !== "127.0.0.1"
    ) {
      that.TunnelsData = JSON.parse(localStorage.getItem("updateLhTunnels"));
      this.getList("image");
      this.getList("video");
      this.getList("speech");
      this.getList("class");
    }
  },
  methods: {
    getList(type) {
      let that = this;
      that.form.itemId = that.TunnelsData.itemId;
      this.form.type = type;
      partyBuilding(this.form).then((res) => {
        if (res.status == 200) {
          if (type == "image") {
            this.imageList = res.data.rows;
          } else if (type == "video") {
            this.videoList = res.data.rows;
          } else if (type == "speech") {
            this.speechList = res.data.rows;
          } else if (type == "class") {
            this.partyClassList = res.data.rows;
          }
        }
      });
    },
    albumHandleQuery(item) {
      this.title = item.albumTitle;
      this.content = item.albumContent;
      this.imageLists = item.imageList;
      this.drawer = true;
    },
    videoHandleQuery(item) {
      this.title = item.videoTitle;
      this.content = item.videoContent;
      this.videoSource = item.videoList[0];
      this.drawer = true;
    },
    speechHandleQuery(item) {
      console.log(item);
      this.title = item.speechTitle;
      this.content = item.speechContent;
      this.drawer = true;
    },
    classHandleQuery(item) {
      this.title = item.classTitle;
      this.content = item.classContent;
      this.drawer = true;
    },
    handleClose(done) {
      this.title = "";
      this.content = "";
      this.imageLists = [];
      this.videoSource = "";
      done();
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped>
/* 引入字体 */
@font-face {
  font-family: "DS-Digital";
  src: url("../font/DS-DIGIB.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.cloud-partyBuilding {
  width: 100%;
  height: 100%;
  text-align: left;
  background-image: url(@/assets/images/partyBuilding-bgs.png);
  background-attachment: fixed;     /* 背景固定，不随页面滚动 */
  background-size: cover;           /* 拉伸并裁剪以完全覆盖容器 */
  background-position: center;      /* 居中显示，避免重要内容被裁掉 */
  background-repeat: no-repeat;     /* 禁止平铺（cover 模式下通常不需要重复） */

  > .cloud-partyBuilding-l {
    position: relative;
    width: calc(400 / 1920 * 100vw);
    height: calc(920 / 1080 * 100vh);
    margin-left: calc(20 / 1920 * 100vw);
    top: 1vh;
    float: left;
    overflow: hidden;
    border-radius: 30px;
  }

  > .cloud-partyBuilding-c {
    position: relative;
    width: calc(1045 / 1920 * 100vw);
    height: calc(910 / 1080 * 100vh);
    margin-left: calc(20 / 1920 * 100vw);
    top: 2vh;
    float: left;
    overflow: hidden;
    border-radius: 5px;
    /* background-image: url("@/assets/images/partyBuilding-bg.png");
    background-size: 100% 100%; */
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;
  }

  > .cloud-partyBuilding-r {
    position: relative;
    width: calc(400 / 1920 * 100vw);
    height: calc(920 / 1080 * 100vh);
    top: 1vh;
    margin-left: calc(20 / 1920 * 100vw);
    float: left;
    overflow: hidden;
    border-radius: 30px;
  }

  .cloud-partyBuilding-title {
    position: absolute;
    top: 1vh;
    left: 0;
    width: 100%;
    height: calc(920 / 1080 * 100vh);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;

    .cloud-partyBuilding-title-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;

      > img {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
      }

      > p {
        position: absolute;
        top: 0.3vh;
        left: 3.01vh;
        width: 100%;
        height: 2.5vh;
        margin: 0;
        padding: 0;
        font-size: 1rem;
        color: #fff;
        text-align: left;
      }

      > div {
        position: absolute;
        top: 0.3vh;
        right: 1vw;
        width: 100px;
        height: 4vh;
        line-height: 4vh;
        text-align: center;
        float: right;
        margin-top: 0vh;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 0.8rem;
        color: #f8f6f6;
        text-align: right;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }

    .cloud-partyBuilding-title-content {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: calc(870 / 1080 * 100vh);
      margin: 0;
      padding: 0;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
    }
  }

  .cloud-partyBuilding-c-title {
    width: 300px;
    height: 3vh;
    margin: 0;
    padding: 0;
    background-image: url("@/assets/images/partyBuilding-title.png");
    background-size: 100% 100%;
    padding-left: 2vw;
  }

  .ulTable {
    width: 95%;
    height: auto;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    margin-top: 3vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(150, 150, 150, 0.2) transparent;

    > li {
      width: 90%;
      height: 3vh;
      line-height: 3vh;
      font-size: 1rem;
      color: #f8f5f5;
      text-align: left;
      border-radius: 0px 0px 0px 0px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      font-size: 0.8rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }

  ::v-deep .node-label {
    color: #fdf8f8 !important
  }
}
</style>